import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPartnerBusinessProfileResponse } from '../type/types';
import { api } from '../axiosInstance';

export const getPartnerBusinessProfile = async () => {
  const res = await api.get<ApiResponseType<GetPartnerBusinessProfileResponse>>(
    '/api/web/partners/profile'
  );
  return res.data;
};
